"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IkeCollectionUpgrade = void 0;
var tslib_1 = require("tslib");
var core_api_1 = require("@ikegps/core-api");
var __1 = require("..");
var __2 = require("../..");
var collection_upgrade_action_1 = require("./collection.upgrade.action");
var IkeCollectionUpgrade = /** @class */ (function () {
    function IkeCollectionUpgrade(collections, targetForm) {
        this.validations = {};
        this.actions = {};
        this.collections = collections;
        this.targetForm = targetForm;
    }
    /** Add a migration action for a field, eg drop, replace */
    IkeCollectionUpgrade.prototype.addAction = function (action) {
        if (this.actions[action.fieldId]) {
            throw new Error('Duplicate action fieldId: ' + action.fieldId);
        }
        this.actions[action.fieldId] = collection_upgrade_action_1.IkeCollectionUpgradeActionFactory.createAction(action);
        return this;
    };
    IkeCollectionUpgrade.prototype.process = function (log) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var output, _a, _b, oldCollection, newCollection, _c, _d, e_1_1, validations;
            var e_1, _e;
            var _this = this;
            return tslib_1.__generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        output = [];
                        _f.label = 1;
                    case 1:
                        _f.trys.push([1, 8, 9, 10]);
                        _a = tslib_1.__values(this.collections), _b = _a.next();
                        _f.label = 2;
                    case 2:
                        if (!!_b.done) return [3 /*break*/, 7];
                        oldCollection = _b.value;
                        _d = (_c = __2.IkeModel.Collection).read;
                        return [4 /*yield*/, __2.IkeModel.Collection.write(oldCollection)];
                    case 3:
                        newCollection = _d.apply(_c, [_f.sent(), this.targetForm, oldCollection.loader]);
                        return [4 /*yield*/, newCollection.ready()];
                    case 4:
                        _f.sent();
                        return [4 /*yield*/, this.processSubForm(oldCollection, newCollection, log.child({ collectionId: oldCollection.id }))];
                    case 5:
                        _f.sent();
                        output.push(newCollection);
                        _f.label = 6;
                    case 6:
                        _b = _a.next();
                        return [3 /*break*/, 2];
                    case 7: return [3 /*break*/, 10];
                    case 8:
                        e_1_1 = _f.sent();
                        e_1 = { error: e_1_1 };
                        return [3 /*break*/, 10];
                    case 9:
                        try {
                            if (_b && !_b.done && (_e = _a.return)) _e.call(_a);
                        }
                        finally { if (e_1) throw e_1.error; }
                        return [7 /*endfinally*/];
                    case 10:
                        validations = Object.keys(this.validations);
                        if (validations.length > 0) {
                            return [2 /*return*/, { result: 'failure', fields: validations.map(function (c) { return _this.validations[c]; }) }];
                        }
                        return [2 /*return*/, { result: 'success', collections: output }];
                }
            });
        });
    };
    IkeCollectionUpgrade.prototype.findMatchingField = function (field, oldSubForm, newSubForm) {
        // If the action maps the field then use that
        var action = this.actions[field.id];
        if (action != null) {
            return action.targetFieldId;
        }
        // Attempt to look for a matching field by display name
        var sourceMatches = oldSubForm.fields.filter(function (f) { return f.displayName === field.displayName && f.type === field.type; });
        if (sourceMatches.length > 1) {
            // Multiple source fields, skip
            return null;
        }
        var matches = newSubForm.fields.filter(function (f) { return f.displayName === field.displayName && f.type === field.type; });
        if (matches.length !== 1) {
            // Multiple target fields, skip
            return null;
        }
        return matches[0].id;
    };
    IkeCollectionUpgrade.prototype.getAction = function (oldField) {
        return this.actions[oldField.schema.id];
    };
    IkeCollectionUpgrade.prototype.processSubForm = function (oldSubForm, newSubForm, log) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var failures, _a, _b, schemaField, oldField, targetFieldId, action, newDropField, isActionProcessed, targetField, newField, _c, _d, oldInstance, newInstance, res, e_2_1, isActionProcessed, oldFormVersion, newFormVersion, isIPFUpgrade, e_3_1;
            var e_3, _e, e_2, _f;
            var _g, _h, _j, _k, _l, _m, _o, _p;
            return tslib_1.__generator(this, function (_q) {
                switch (_q.label) {
                    case 0:
                        failures = [];
                        _q.label = 1;
                    case 1:
                        _q.trys.push([1, 13, 14, 15]);
                        _a = tslib_1.__values(oldSubForm.schema.fields), _b = _a.next();
                        _q.label = 2;
                    case 2:
                        if (!!_b.done) return [3 /*break*/, 12];
                        schemaField = _b.value;
                        oldField = oldSubForm.getField(schemaField.id);
                        if (!oldField.hasValue()) {
                            return [3 /*break*/, 11];
                        }
                        // handle undefined yes/no field
                        if (oldField.schema.type === core_api_1.IkeFieldType.YES_NO && oldField.displayValue === 'undefined') {
                            return [3 /*break*/, 11];
                        }
                        targetFieldId = schemaField.id;
                        action = this.getAction(oldField);
                        // Handle 'drop' as a special case when target form does not have field defined
                        if (action != null && !action.requiresTargetField) {
                            if (newSubForm.hasField(targetFieldId)) {
                                newDropField = newSubForm.getField(targetFieldId);
                                isActionProcessed = action.process(oldField, newDropField, log);
                                if (isActionProcessed) {
                                    log.trace({ oldFieldId: oldField.id, newFieldId: newDropField.id, action: action.reason }, 'Applied action');
                                }
                            }
                            return [3 /*break*/, 11];
                        }
                        // Attempt to find the mapping for a missed field
                        if (!newSubForm.schema.hasField(schemaField.id)) {
                            targetFieldId = this.findMatchingField(schemaField, oldSubForm.schema, newSubForm.schema);
                            if (targetFieldId == null) {
                                log.warn({ fieldId: schemaField.id }, 'Unable to find field mapping');
                                this.validations[schemaField.id] = { reason: 'missing', fieldId: schemaField.id, fieldName: schemaField.displayName };
                                return [3 /*break*/, 11];
                            }
                            if (oldField.schema.type !== core_api_1.IkeFieldType.FORM) {
                                targetField = newSubForm.getField(targetFieldId);
                                targetField.Mutator.copy(oldField);
                            }
                        }
                        newField = newSubForm.getField(targetFieldId);
                        // field types have changed... TODO handle this
                        if (newField.schema.type !== oldField.schema.type) {
                            log.error({ oldFieldId: schemaField.id, newFieldId: newField.id, oldType: oldField.schema.type, newType: newField.schema.type }, 'Mapping invalid types');
                            throw new Error('Cannot map between types');
                        }
                        if (!(__1.CollectionModelFieldSubForm.isSubFormField(oldField) && __1.CollectionModelFieldSubForm.isSubFormField(newField))) return [3 /*break*/, 10];
                        _q.label = 3;
                    case 3:
                        _q.trys.push([3, 8, 9, 10]);
                        _c = (e_2 = void 0, tslib_1.__values(oldField.value)), _d = _c.next();
                        _q.label = 4;
                    case 4:
                        if (!!_d.done) return [3 /*break*/, 7];
                        oldInstance = _d.value;
                        newInstance = this.getOrCreateSubformInstance(newField, oldInstance.instanceId);
                        return [4 /*yield*/, this.processSubForm(oldInstance, newInstance, log)];
                    case 5:
                        res = _q.sent();
                        if (res.length > 0) {
                            failures = failures.concat(res);
                        }
                        _q.label = 6;
                    case 6:
                        _d = _c.next();
                        return [3 /*break*/, 4];
                    case 7: return [3 /*break*/, 10];
                    case 8:
                        e_2_1 = _q.sent();
                        e_2 = { error: e_2_1 };
                        return [3 /*break*/, 10];
                    case 9:
                        try {
                            if (_d && !_d.done && (_f = _c.return)) _f.call(_c);
                        }
                        finally { if (e_2) throw e_2.error; }
                        return [7 /*endfinally*/];
                    case 10:
                        if (action != null && action.process != null) {
                            isActionProcessed = action.process(oldField, newField, log);
                            if (isActionProcessed) {
                                log.trace({ oldFieldId: oldField.id, newFieldId: newField.id, action: action.reason }, 'Applied action');
                                return [3 /*break*/, 11];
                            }
                        }
                        if (newField.displayValue !== oldField.displayValue) {
                            oldFormVersion = (_k = (_j = (_h = (_g = oldSubForm.schema.getForm().metadata).getIkePoleForeman) === null || _h === void 0 ? void 0 : _h.call(_g)) === null || _j === void 0 ? void 0 : _j.formVersion) !== null && _k !== void 0 ? _k : 1;
                            newFormVersion = (_p = (_o = (_m = (_l = this.targetForm) === null || _l === void 0 ? void 0 : _l.metadata) === null || _m === void 0 ? void 0 : _m.getIkePoleForeman) === null || _o === void 0 ? void 0 : _o.call(_m)) === null || _p === void 0 ? void 0 : _p.formVersion;
                            isIPFUpgrade = ((oldField.schema.id === 'ipf_serviceCommunicationsCable' || oldField.schema.id === 'ipf_servicePowerConductor') &&
                                newFormVersion !== undefined &&
                                oldFormVersion < 3 && newFormVersion >= 3);
                            if (isIPFUpgrade) {
                                newField.Mutator.truncatedCopy(oldField);
                            }
                            else {
                                log.error({ oldFieldId: schemaField.id, oldDisplay: oldField.displayValue, newDisplay: newField.displayValue }, 'Display miss match');
                                this.addReplaceValue(schemaField, oldField.displayValue);
                            }
                        }
                        _q.label = 11;
                    case 11:
                        _b = _a.next();
                        return [3 /*break*/, 2];
                    case 12: return [3 /*break*/, 15];
                    case 13:
                        e_3_1 = _q.sent();
                        e_3 = { error: e_3_1 };
                        return [3 /*break*/, 15];
                    case 14:
                        try {
                            if (_b && !_b.done && (_e = _a.return)) _e.call(_a);
                        }
                        finally { if (e_3) throw e_3.error; }
                        return [7 /*endfinally*/];
                    case 15: return [2 /*return*/, failures];
                }
            });
        });
    };
    IkeCollectionUpgrade.prototype.getOrCreateSubformInstance = function (subform, instanceId) {
        var newInstance = subform.getInstance(instanceId);
        if (newInstance != null) {
            return newInstance;
        }
        subform.Mutator.create(instanceId);
        return subform.getInstance(instanceId);
    };
    IkeCollectionUpgrade.prototype.addReplaceValue = function (field, value) {
        var existing = this.validations[field.id] || { fieldId: field.id, fieldName: field.displayName, reason: 'replace', values: [] };
        if (existing.reason !== 'replace') {
            throw new Error('Missing and Replace: ' + field.id);
        }
        if (existing.values.indexOf(value) > -1) {
            return;
        }
        existing.values.push(value);
        this.validations[field.id] = existing;
    };
    return IkeCollectionUpgrade;
}());
exports.IkeCollectionUpgrade = IkeCollectionUpgrade;
//# sourceMappingURL=collection.upgrade.js.map